export default __webpack_public_path__ + "static/media/karlis.a549f4c1.jpg";